export default __webpack_public_path__ + "static/quote-6-5724005bcc4af0bfd6086f30481f163d.mp3";